<template>
    <button-block
        without-loading
        @completed="onButtonClick"
    >
        <svg-icon :icon="IconAdd" />
        Nieuwe flow
    </button-block>

    <create-flow-from-template-modal
        ref="modal"
        @flow-created="onFlowCreated"
        @flow-requested="onFlowRequested"
    />
</template>

<script setup lang="ts">
    import {
        ButtonState,
        type ButtonStateChangedEvent,
        ButtonBlock,
        type ExposedOverlay,
        SvgIcon,
    } from '@keyvue/one-ui';

    import CreateFlowFromTemplateModal from '@/flow/template/components/CreateFlowFromTemplateModal.vue';
    import IconAdd from '@keyvue/one-material-icons/icons/add.svg?component';
    import { useRouter } from 'vue-router';
    import { ref } from 'vue';

    const router = useRouter();
    const modal = ref<ExposedOverlay>();

    function onButtonClick(event: ButtonStateChangedEvent) {
        event.button.setState(ButtonState.content);
        modal.value?.openOverlay();
    }

    function onFlowCreated(flowId: string) {
        modal.value?.closeOverlay();

        router.push({
            name: 'edit-flow-created',
            params: {
                flowId,
            },
        });
    }

    function onFlowRequested() {
        modal.value?.closeOverlay();
    }
</script>
